import { loadOnInteraction } from "./includes/utils.js";
import adInit from "./libs/nuwara-ads/index.js";

loadOnInteraction({
  callback: () => {
    adInit();
  },
});